import React from 'react';
  
  const Index = () =>  {
	return (
	  <div>
	  </div>
	);
  }
  
  export default Index;
  export {default as UserList} from './UserList'
export {default as UpdateUserModal} from './UpdateUserModal'